<!-- eslint-disable vue/valid-v-for -->
<template>
  <!-- <div class="box">
    <span>*点击按钮即视为同意灵播管家企业版 《<span @click="openLink('a')" class="a_link">用户服务协议</span>》和 《<span @click="openLink('b')"
        class="a_link">隐私政策</span>》</span>
  </div> -->
  <div class="box" v-html="appLoginAgreement"></div>
</template>

<script>
import { isJSONString, setFavicon } from "@/utils/utils";

export default {
  name: "Privacy",
  components: {},
  data() {
    return {
      appLoginAgreement: "",
    };
  },
  created() {},
  mounted() {
    try {
      if (isJSONString("uiInfo")) {
        const uiInfo = JSON.parse(localStorage.getItem("uiInfo"));
        this.appLoginAgreement = uiInfo.appLoginAgreement.replace(
          /\[《(.*?)》\]\((.*?)\)/g,
          ` 《<a style="color:#4D4DFF;" href="$2">$1</a>》 `
        );
      }
    } catch (error) {}
  },
};
</script>
<style scoped>
a {
  color: #4D4DFF !important;
  cursor: pointer;
}

.box {
  padding: 12px 0;
  width: 100%;
  text-align: center;
  color: #a9a8a9;
}
</style>
